import Icon from '@/components/svg/icon'
import type { ProductPreviewCardFragment } from '@/lib/types/datocms/graphql/generated'
import clsx from 'clsx'

export default function ProductDetailAccordion({
	idx,
	title,
	activeAccordion,
	handleAccordionClick,
	content,
	className,
}: Readonly<{
	idx: string
	title: string
	activeAccordion: string | null
	handleAccordionClick: (idx: string) => void
	content?: React.ReactNode
	className?: string
	possibleHeadrampCombinations?: ProductPreviewCardFragment[]
	setActiveMegaMenu?: (open: string) => void
	setShowMobileMenu?: (show: boolean) => void
}>) {
	return (
		<>
			<button
				className={clsx(
					'flex justify-between items-center font-semibold border-t shrink-0 py-4',
					className
				)}
				onClick={() => handleAccordionClick(idx)}
			>
				<span>{title}</span>
				<Icon
					icon="Chevron"
					className={clsx(
						'w-4 h-3.5 transition-transform duration-200 text-blue',
						activeAccordion === idx ? '-rotate-90' : 'rotate-90'
					)}
				/>
			</button>
			<div
				className={`grid text-sm overflow-hidden transition-all duration-500 ease-in-out shrink-0 ${
					activeAccordion === idx ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
				}`}
			>
				<div className="overflow-hidden">{content}</div>
			</div>
		</>
	)
}
